import { useFormFieldValue } from 'react-simple-hooks-forms/dist'
import { ReactElement } from 'react'

interface SubmitButtonProps {
  formName?: string
  requiredFormFields: string[]
  children: (disabled: boolean) => ReactElement
}

export const FormCompletenessValidator: React.FunctionComponent<SubmitButtonProps> = props => {
  let allFieldsPresent = true

  for (let i = 0; i < props.requiredFormFields.length; i++) {
    const { value: fieldValue } = useFormFieldValue(props.requiredFormFields[i], { formName: props.formName })
    if (!fieldValue) {
      allFieldsPresent = false
    }
  }

  return props.children(!allFieldsPresent)
}
